import { useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Step3.css";

const Step3 = () => {
  const navigate = useNavigate();

  const onLogo1ContainerClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onButtonDesktopSecondaryContainerClick = useCallback(() => {
    navigate("/step2");
  }, [navigate]);

  const onButtonDesktopSecondaryContainer1Click = useCallback(() => {
    navigate("/create-account");
  }, [navigate]);

  const onButtonDesktopSecondaryContainer3Click = useCallback(() => {
    navigate("/step1");
  }, [navigate]);

  return (
    <div className="step3-div">
      <div className="frame-div60">
        <div className="logo1-div4" onClick={onLogo1ContainerClick}>
          <img className="vector-icon105" alt="" src="../vector105.svg" />
          <img className="vector-icon106" alt="" src="../vector56.svg" />
          <img className="vector-icon107" alt="" src="../vector107.svg" />
          <img className="vector-icon108" alt="" src="../vector58.svg" />
          <img className="vector-icon109" alt="" src="../vector84.svg" />
          <img className="vector-icon110" alt="" src="../vector110.svg" />
          <img className="vector-icon111" alt="" src="../vector61.svg" />
          <img className="vector-icon112" alt="" src="../vector112.svg" />
          <img className="vector-icon113" alt="" src="../vector63.svg" />
          <img className="vector-icon114" alt="" src="../vector89.svg" />
          <img className="vector-icon115" alt="" src="../vector90.svg" />
          <img className="vector-icon116" alt="" src="../vector91.svg" />
          <img className="vector-icon117" alt="" src="../vector117.svg" />
          <img className="vector-icon118" alt="" src="../vector118.svg" />
          <img className="vector-icon119" alt="" src="../vector119.svg" />
          <img className="vector-icon120" alt="" src="../vector95.svg" />
          <img className="vector-icon121" alt="" src="../vector71.svg" />
          <img className="vector-icon122" alt="" src="../vector122.svg" />
          <img className="vector-icon123" alt="" src="../vector123.svg" />
          <img className="vector-icon124" alt="" src="../vector124.svg" />
          <img className="vector-icon125" alt="" src="../vector125.svg" />
          <img className="vector-icon126" alt="" src="../vector126.svg" />
          <img className="vector-icon127" alt="" src="../vector127.svg" />
          <img className="vector-icon128" alt="" src="../vector128.svg" />
          <img className="vector-icon129" alt="" src="../vector129.svg" />
          <b className="shuleeazy-b4">ShuleEazy</b>
        </div>
      </div>
      <div className="frame-div61">
        <div className="frame-div62">
          <b className="step-3-of-3">Step 3 of 3</b>
          <b className="what-are-you-interested-in-lea">
            What are you interested in learning?
          </b>
        </div>
        <b className="please-select-atleast-3">Please select atleast 3</b>
      </div>
      <div className="frame-div63">
        <div className="frame-div64">
          <div className="card2-div">
            <div className="frame-div65">
              <img className="music-icon1" alt="" src="../music1.svg" />
            </div>
            <b className="music-b">Music</b>
            <Form.Check
              className="rectangle-formcheck"
              name="step3"
              id="step3"
            />
          </div>
          <div className="card2-div1">
            <div className="frame-div65">
              <img className="music-icon1" alt="" src="../music2.svg" />
            </div>
            <b className="music-b">Music</b>
            <Form.Check
              className="rectangle-formcheck"
              name="step3"
              id="step3"
            />
          </div>
          <div className="card2-div">
            <div className="frame-div65">
              <img className="music-icon1" alt="" src="../music3.svg" />
            </div>
            <b className="music-b">Music</b>
            <Form.Check
              className="rectangle-formcheck"
              name="step3"
              id="step3"
            />
          </div>
          <div className="card2-div">
            <div className="frame-div65">
              <img className="music-icon1" alt="" src="../music4.svg" />
            </div>
            <b className="music-b">Music</b>
            <Form.Check
              className="rectangle-formcheck"
              name="step3"
              id="step3"
            />
          </div>
        </div>
        <div className="frame-div64">
          <div className="card2-div">
            <div className="frame-div65">
              <img className="music-icon1" alt="" src="../music5.svg" />
            </div>
            <b className="music-b">Music</b>
            <Form.Check
              className="rectangle-formcheck"
              name="step3"
              id="step3"
            />
          </div>
          <div className="card2-div">
            <div className="frame-div65">
              <img className="music-icon1" alt="" src="../music6.svg" />
            </div>
            <b className="music-b">Music</b>
            <Form.Check
              className="rectangle-formcheck"
              name="step3"
              id="step3"
            />
          </div>
          <div className="card2-div">
            <div className="frame-div65">
              <img className="music-icon1" alt="" src="../music7.svg" />
            </div>
            <b className="music-b">Music</b>
            <Form.Check
              className="rectangle-formcheck"
              name="step3"
              id="step3"
            />
          </div>
          <div className="card2-div">
            <div className="frame-div65">
              <img className="music-icon1" alt="" src="../music8.svg" />
            </div>
            <b className="music-b">Music</b>
            <Form.Check
              className="rectangle-formcheck"
              name="step3"
              id="step3"
            />
          </div>
        </div>
        <div className="frame-div64">
          <div className="card2-div">
            <div className="frame-div65">
              <img className="music-icon1" alt="" src="../music9.svg" />
            </div>
            <b className="music-b">Music</b>
            <Form.Check
              className="rectangle-formcheck"
              name="step3"
              id="step3"
            />
          </div>
          <div className="card2-div">
            <div className="frame-div65">
              <img className="music-icon1" alt="" src="../music10.svg" />
            </div>
            <b className="music-b">Music</b>
            <Form.Check
              className="rectangle-formcheck"
              name="step3"
              id="step3"
            />
          </div>
        </div>
      </div>
      <div className="frame-div77">
        <div
          className="buttondesktopsecondary-div4"
          onClick={onButtonDesktopSecondaryContainerClick}
        >
          <b className="save-and-next11">Prev</b>
        </div>
        <div
          className="buttondesktopsecondary-div4"
          onClick={onButtonDesktopSecondaryContainer1Click}
        >
          <b className="save-and-next11">NEXT</b>
        </div>
      </div>
      <div
        className="buttondesktopsecondary-div6"
        onClick={onButtonDesktopSecondaryContainer3Click}
      >
        <div className="buttondesktopsecondary-div7">
          <b className="save-and-next11">RESET</b>
        </div>
      </div>
    </div>
  );
};

export default Step3;
